export { YgIconComponent } from './yg-icon.component';
export { YgIconModule } from './yg-icon.module';
